module.exports = __webpack_public_path__ + "img/i1.15582a27.png";